<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M7.6 20q-.6 0-1.1-.5T6 18.4V6H5V5h4v-.8h6V5h4v1h-1v12.4q0 .6-.5 1.1t-1.1.5zM17 6H7v12.4q0 .3.2.4l.4.2h8.8q.2 0 .4-.2l.2-.4zM9.8 17h1V8h-1zm3.4 0h1V8h-1z"
      />
    </svg>
  </span>
</template>
